import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(onChange: () => void): () => void {
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}

/**
 * Kert-e a nezo csokkentett mozgast.
 *
 * A CSS-animaciokat a `styles.css` globalisan leallitja - ez a hook a JS-bol
 * vezerelt mozgasnak kell (pl. animalt GIF helyett allo kocka). Figyeli a
 * valtozast is, igy a rendszerbeallitas atallitasa azonnal ervenyes.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
